import script from "./ImportButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportButton.vue?vue&type=script&setup=true&lang=ts"

import "./ImportButton.vue?vue&type=style&index=0&id=1b1f27c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1f27c8"]])

export default __exports__